import { Injectable, OnInit, Injector } from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";

export interface IProgrammingSelected {
    id: number;
    name: string;
    userId: number;
    programmingId: number;
    calendarId: number;
}

@Injectable()
export class ProgrammingHelperService extends AppComponentBase {

    userLogged = this.appSession.user;

    constructor(
        injector: Injector
    ) {
        super(injector);
        this.checkProgramming();
    }

    checkProgramming(): void {

        let programming: IProgrammingSelected = this.loadProgrammingSelected();

        if (!this.userLogged || !programming || programming.userId != this.userLogged.id) {
            localStorage.removeItem('programming');
        }        
    }

    loadProgrammingSelected(): IProgrammingSelected {
        return JSON.parse(localStorage.getItem('programming'));
    }

    save(programming: IProgrammingSelected): void {        
        localStorage.setItem('programming', JSON.stringify(programming));
    }
}



// WEBPACK FOOTER //
// ./src/app/scientific/programming-header/programming-helper-service.ts